export default __webpack_public_path__ + "static/media/1-9@2x.1e416ff5.png";